import React, { useEffect, useState } from 'react';
import { WizardContent } from '../../components/WizardContent';
import { WizardTitle } from '../../components/WizardTitle';
import WizardButton from '../../components/WizardButton';
import { Form, Link } from './ServiceLocation.styles';
import WizardTextField from '../../components/WizardTextField';
import IFormError from '../../../../interfaces/IFormError';
import * as yup from 'yup';
import { useValidateSchema } from '../../../../hooks/providers/useValidateSchema';
import IWizardStep from '../../../../interfaces/IWizardStep';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import ITypeDocument from '../../../../interfaces/ITypeDocument';

interface ServiceLocationProps extends IWizardStep {}

const ServiceLocation = (props: ServiceLocationProps) => {
  const [loading, setLoading] = useState(false);
  const [clinicName, setClinicName] = useState('');
  const [errors, setErrors] = useState<IFormError>();
  const vallidationProvader = useValidateSchema();
  const [documentType, setDocumentType] = useState<ITypeDocument | null>(null);

  const localStorage = useLocalStorage();

  const schema = yup.object({
    clinicName: yup.string().test((clinicName, schema) => clinicNameValidation(`${clinicName}`, schema)),
  });

  const clinicNameValidation = (clinicName: string, schema: yup.TestContext): yup.ValidationError | boolean => {
    if (!clinicName) {
      return schema.createError({ message: `Campo obrigatório` });
    }
    return true;
  };

  useEffect(() => {
    if (props.medicalCertificate.typeDocument?.showHospital === false) {
      advanceWhithoutData();
    }
    setClinicName(props.medicalCertificate.clinicName || '');
    const documentType: ITypeDocument = localStorage.getItem('documentType');
    setDocumentType(documentType);
  }, []);

  const advanceWhithoutData = async () => {
    await props
      .setStep(props.step + 1, { ...props.medicalCertificate }, props.step)
      .then(() => {
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const result = await vallidationProvader.validate(schema, { clinicName });

    setErrors({ ...result.errors });
    if (!result.isValid) {
      setLoading(false);
      return;
    }

    setLoading(false);
    await props.setStep(props.step + 1, { ...props.medicalCertificate, clinicName }, props.step);
  };

  return (
    <WizardContent>
      <WizardTitle>Informe o nome do local onde foi realizado seu atendimento:</WizardTitle>
      <Form onSubmit={handleSubmit}>
        <WizardTextField
          label="Nome do local"
          placeholder="Nome do local"
          value={clinicName}
          onChange={e => {
            setClinicName(e.target.value);
          }}
          sx={{ marginBottom: '5px', width: '300px' }}
          variant="outlined"
          error={Boolean(errors?.clinicName)}
          helperText={errors?.clinicName}
          autoFocus
        />
        {!documentType?.hospitalRequired && <Link onClick={advanceWhithoutData}>Não tenho essa informação</Link>}
        <WizardButton type="submit" isLoading={loading} disabled={loading} sx={{ marginTop: '35px' }}>
          PRÓXIMO
        </WizardButton>
      </Form>
    </WizardContent>
  );
};

export default ServiceLocation;
